export const VERIFY_PASSWORD_RESET_CODE_REQUEST = 'VERIFY_PASSWORD_RESET_CODE_REQUEST';
export const VERIFY_PASSWORD_RESET_CODE_SUCCESS = 'VERIFY_PASSWORD_RESET_CODE_SUCCESS';
export const VERIFY_PASSWORD_RESET_CODE_FAILURE = 'VERIFY_PASSWORD_RESET_CODE_FAILURE';

export const SET_PASSWORD_AND_VERIFY_EMAIL_REQUEST = 'SET_PASSWORD_AND_VERIFY_EMAIL_REQUEST';
export const SET_PASSWORD_AND_VERIFY_EMAIL_SUCCESS = 'SET_PASSWORD_AND_VERIFY_EMAIL_SUCCESS';
export const SET_PASSWORD_AND_VERIFY_EMAIL_FAILURE = 'SET_PASSWORD_AND_VERIFY_EMAIL_FAILURE';

export const SET_STEP = 'ONBOARDING_SET_STEP';